import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { API_BASE_URL, getBearerToken } from '../../functions';
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
import ToastMessage from '../ToastMessage';

const AddAirline = ({ show, setShow, editData }) => {
    const handleClose = () => setShow(false);
    const [toastMessage, setToastMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    // const Navigate = useNavigate()
    const [editMode, setEditMode] = useState(false);



    const [data, setData] = useState({
        full_name: '',
        short_name: '',
        logo: null,
    });

    useEffect(() => {
        // If editData is provided, update the data state with the editData
        if (editData) {
            setData({ ...editData });
            setEditMode(true);
        } else {
            // If editData is not provided, reset the data state for adding a new sector
            setData({
                sector_name: '',
                from_sector: '',
                to_sector: '',
                image: null,
            });
            setEditMode(false);
        }
    }, [editData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('full_name', data.full_name);
        formData.append('short_name', data.short_name);
        formData.append('logo', data.logo);

        if (editMode) {
            // Update an existing airline
            // Assuming editData contains the ID of the airline to be updated
            axios
                .post(`${API_BASE_URL}/updateariline/${editData.id}`, formData, {
                    headers: {
                        'Authorization': `Bearer ${getBearerToken()}`
                    }
                })
                .then((response) => {
                    setToastMessage({ type: 'success', message: 'Airline updated successfully!', show: 'show' });
                    window.location.reload();
                    setLoading(false);
                    handleClose();
                })
                .catch((error) => {
                    setToastMessage({ type: 'error', message: error });
                    setLoading(false);
                });
        } else {
            // Add a new airline
            axios
                .post(`${API_BASE_URL}/add-airline`, formData, {
                    headers: {
                        'Authorization': `Bearer ${getBearerToken()}`
                    }
                })
                .then((response) => {
                    setToastMessage({ type: 'success', message: 'Airline added successfully!', show: 'show' });
                    window.location.reload();
                    setLoading(false);
                    handleClose();
                })
                .catch((error) => {
                    setToastMessage({ type: 'error', message: error });
                    setLoading(false);
                });
        }
    };


    return (
        <>
            {toastMessage && <ToastMessage type={toastMessage.type} message={toastMessage.message} show={toastMessage.show} />}
            <Modal show={show} size="lg" onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>
                <Form className={'AllForm'} onSubmit={handleSubmit}>

                    <Modal.Header closeButton className="d-flex px-4 align-items-center">
                        <Modal.Title id="contained-modal-title-vcenter">
                            {editMode ? 'Edit Air line' : 'Add Air line'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4">
                        {/*  */}
                        <Row className={'my-4'}>
                            <Col className={'mb-4 mb-lg-0'} xl={'6'} lg={'6'}>
                                <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Air Line Full Name</Form.Label>
                                    <Form.Control required type="text" value={data?.full_name} name={''} id={''} placeholder={'Full Name'} onChange={(e) => setData({ ...data, full_name: e.target.value })} />
                                </Form.Group>
                            </Col>
                            <Col className={'mb-4'} xl={'6'} lg={'6'}>
                                <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Short Name</Form.Label>
                                    <Form.Control required type="text" name={''} id={''} placeholder={'Short Name'} onChange={(e) => setData({ ...data, short_name: e.target.value })} value={data?.short_name} />
                                </Form.Group>
                            </Col>
                            <Col className={'mb-4'} xl={'12'} lg={'12'}>
                                <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Image/Logo</Form.Label>
                                    {!(data?.image === editData?.image) ?
                                        <Form.Control
                                            required={!editData?.image} // Mark as required only when adding a new agent
                                            type="file"
                                            name={''}
                                            id={''}
                                            placeholder={'Airline image/logo'}
                                            onChange={(e) => setData({ ...data, logo: e.target.files[0] })}
                                        />
                                        :
                                        <div className="d-flex align-items-center">
                                            <img src={data?.logo} alt="Agent" width="100" height="100" className="me-2" />
                                            <Button variant="outline-danger" size="sm" onClick={() => setData({ ...data, image: null })}>
                                                Remove Image
                                            </Button>
                                            {/* // Check if data.image is falsy (no image is present) */}

                                        </div>
                                    }
                                </Form.Group>
                            </Col>
                        </Row>

                    </Modal.Body>
                    {/*  */}
                    <Modal.Footer className="">
                        <Button variant="" className="w-100px F1F1F1bg fontsize14 fontweight700 me-3" onClick={handleClose}>Cancel</Button>
                        <Button variant="" disabled={loading} type='submit' className="w-100px text-white fontweight700 fontsize14 brandMainColorBg">
                            {loading ?
                                <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
                                : editMode ? 'Update' : 'Save'
                            }
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default AddAirline;